const CopyIcon = ({ className = "", ...props }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    focusable="false"
    aria-hidden="true"
    {...props}
  >
    <rect
      x="8"
      y="8"
      width="11"
      height="13"
      rx="1.5"
      stroke="currentColor"
      strokeWidth="1.8"
    />
    <path
      d="M16 8V5.5A1.5 1.5 0 0 0 14.5 4H6.5A1.5 1.5 0 0 0 5 5.5v10A1.5 1.5 0 0 0 6.5 17H8"
      stroke="currentColor"
      strokeWidth="1.8"
    />
  </svg>
);

export default CopyIcon;
